interface ProgressCircleProps {
  value: number;
  maxValue?: number;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export const ProgressCircle: React.FC<ProgressCircleProps> = ({
  value,
  maxValue = 10,
  size = 64,
  strokeWidth = 4,
  className = '',
}) => {
  // Calculate percentage
  const percentage = Math.min(100, (value / maxValue) * 100);

  // Calculate circle properties
  const radius = size / 2 - strokeWidth;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  // Determine color based on score
  const getScoreColor = (score: number) => {
    const normalizedScore = (score / maxValue) * 10;
    if (normalizedScore >= 8) return 'text-[#089E71]';
    if (normalizedScore >= 6) return 'text-[#1C7AEB]';
    if (normalizedScore >= 4) return 'text-[#FF9A42]';
    return 'text-red-600';
  };

  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="transform -rotate-90"
      >
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
        />

        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          className={getScoreColor(value)}
        />
      </svg>

      {/* Score text */}
      <div className={`absolute inset-0 flex items-center justify-center`}>
        <span className="text-xxl font-medium">{value.toFixed(1)}</span>
      </div>
    </div>
  );
};
